import React from 'react';
import { SkeletonLine, SkeletonBlock } from '@one-thd/sui-atomic-components';
var ItemsToReturnSkeleton = function () {
    return (React.createElement("div", { className: "sui-my-24 sui-mt-4", "data-testid": "itemsskeleton" },
        React.createElement(SkeletonLine, { variant: "heading" }),
        Array.from({ length: 2 }, function (unused, index) { return (React.createElement(React.Fragment, { key: index },
            React.createElement("div", { className: "sui-flex sui-flex-row mass-return-skeleton-margin sui-items-start sui-gap-3" },
                React.createElement("div", { id: "massReturnSkeleton" },
                    React.createElement(SkeletonBlock, null)),
                React.createElement("div", { className: "mass-return-skeleton-flex " },
                    React.createElement(SkeletonLine, { numberOfLines: 2 }))),
            React.createElement("div", { className: "sui-mb-5 sui-mt-8" },
                React.createElement(SkeletonLine, { variant: "multi", numberOfLines: 2 })))); }),
        React.createElement("div", { className: "sui-mb-5 sui-mt-8" },
            React.createElement(SkeletonLine, { variant: "multi", numberOfLines: 2 }))));
};
export default ItemsToReturnSkeleton;
